<template>
    <InboxMultiDropDown :dataTrees="responseArray" placement="top-start" @clickList="CannedListClick">
        <slot />
    </InboxMultiDropDown>
</template>

<script setup>
import InboxMultiDropDown from '@/components/multidropdown/InboxMultiDropdown.vue';


const emits = defineEmits(['handleCannedReponse'])
const props = defineProps({
    responseArray: {
        type: Array,
        default: [],
    },
});

const CannedListClick =(d)=>{
   emits('handleCannedReponse', d)
}


</script>

<style scoped></style>
